import React from "react";

interface AdminFilterToolbarProps {
    searchTerm: string;
    onSearchChange: (value: string) => void;
    filters: { id: string; label: string; queryRole: string }[];
    activeFilter: string;
    onFilterChange: (id: string) => void;
    sortOrder: string;
    onSortChange: (value: string) => void;
}

const AdminFilterToolbar: React.FC<AdminFilterToolbarProps> = ({
    searchTerm, 
    onSearchChange, 
    /* filters, 
    activeFilter, 
    onFilterChange, 
    sortOrder, 
    onSortChange */
}) => {
    return (
        <div className="py-3 px-4 md:px-7 border-b border-gray-200 bg-white flex flex-col md:flex-row gap-3 md:items-center shrink-0">
            <div className="flex items-center gap-2 bg-white border border-gray-300 rounded-lg px-3 py-[7px] w-full md:w-auto md:min-w-[260px] focus-within:border-[#4f6df5] focus-within:ring-1 focus-within:ring-[#4f6df5]/20 transition-all shrink-0">
                <svg width="16" height="16" fill="none" stroke="#9ca3af" strokeWidth="2" viewBox="0 0 24 24">
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
                <input
                    type="text"
                    className="bg-transparent border-none outline-none text-[13px] text-gray-900 w-full placeholder:text-gray-400"
                    placeholder="Buscar por nombre, email..."
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
            </div>

            {/* <div className="flex gap-2 overflow-x-auto w-full md:w-auto pb-1 md:pb-0 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                {filters.map((filter) => (
                    <button
                        key={filter.id}
                        className={`text-[11px] font-semibold px-3 py-1.5 rounded-full border transition-all duration-200 whitespace-nowrap shrink-0 ${activeFilter === filter.id
                            ? "bg-[#4f6df5] border-[#4f6df5] text-white shadow-sm"
                            : "bg-white border-gray-200 text-gray-600 hover:text-gray-900 hover:border-gray-300 hover:bg-gray-50"
                            }`}
                        onClick={() => onFilterChange(filter.id)}
                    >
                        {filter.label}
                    </button>
                ))}
            </div> */}

            {/* <select
                className="w-full md:w-auto md:ml-auto bg-white border border-gray-300 rounded-lg py-2 md:py-1.5 px-2.5 text-xs text-gray-700 outline-none cursor-pointer transition-all hover:border-gray-400 hover:bg-gray-50 focus:border-[#4f6df5] focus:ring-1 focus:ring-[#4f6df5]/20 shadow-sm shrink-0"
                value={sortOrder}
                onChange={(e) => onSortChange(e.target.value)}
            >
                <option value="recent">Más recientes</option>
                <option value="oldest">Más antiguos</option>
            </select> */}
        </div>
    );
};

export default AdminFilterToolbar;